export default __webpack_public_path__ + "static/media/feed-management-icon.1261e7c7.svg";